import React from 'react';

const OnboardingSpotlight = ({ elementRect, highlightPadding = 8, disableLeftBackdrop = false, noLeftOffset = false }) => {
  if (!elementRect) {
    return (
      <div className="onboarding-overlay">
        <div className="onboarding-backdrop-full" />
      </div>
    );
  }

  const spotlight = {
    top: elementRect.top - highlightPadding,
    left: noLeftOffset ? elementRect.left : elementRect.left - highlightPadding,
    width: noLeftOffset ? elementRect.width + highlightPadding : elementRect.width + (highlightPadding * 2),
    height: elementRect.height + (highlightPadding * 2)
  };

  return (
    <div className="onboarding-overlay">
      <div
        className="onboarding-backdrop-top"
        style={{
          top: 0,
          left: 0,
          right: 0,
          height: `${spotlight.top}px`
        }}
      />

      {!disableLeftBackdrop && (
        <div
          className="onboarding-backdrop-left"
          style={{
            top: `${spotlight.top}px`,
            left: 0,
            width: `${spotlight.left}px`,
            height: `${spotlight.height}px`
          }}
        />
      )}

      <div
        className="onboarding-backdrop-right"
        style={{
          top: `${spotlight.top}px`,
          left: `${spotlight.left + spotlight.width}px`,
          right: 0,
          height: `${spotlight.height}px`
        }}
      />

      <div
        className="onboarding-backdrop-bottom"
        style={{
          top: `${spotlight.top + spotlight.height}px`,
          left: 0,
          right: 0,
          bottom: 0
        }}
      />

      <div
        className="onboarding-spotlight-ring"
        style={{
          top: `${spotlight.top}px`,
          left: `${spotlight.left}px`,
          width: `${spotlight.width}px`,
          height: `${spotlight.height}px`
        }}
      />
    </div>
  );
};

export default OnboardingSpotlight;
